module.exports = __webpack_public_path__ + "static/img/1.8e48a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/result/1.png
// module id = SwCp
// module chunks = 57